<template>
    <div class="row no-gutters company_info_row" v-if="getBrandLink()" v-cloak>
        <div class="col-12 no-gutters company_info_col">
            <a
                :href="getBrandLink() | appendfragment('cta', 'brand_product_review_info_cta')"
                class="play_now_btn exit-page-link"
                rel="nofollow"
                target="_blank"
                :data-gtm="
                    'brandproduct-info-box-cta-' + brand.brand + '-state ' + state.toLowerCase()
                "
                data-kt="cta:a|ctalocation|operator|product|brand_id|brand_product_id"
                data-ctalocation="brand product review info cta"
                :data-operator="brand.brand"
                :data-product="brand.brand + ' ' + brandProduct.product_type"
                :data-brand_id="brand.id"
                :data-brand_product_id="brandProduct.brand_product_id"
                v-html="getBrandLabel()"
            ></a>
        </div>
        <div class="clearfix"></div>
    </div>
</template>

<script>
export default {
    name: 'sidebar-button',
    props: {
        brand: {
            type: Object,
            required: true,
        },
        brandProduct: {
            type: Object,
            default: false,
        },
        offers: {
            type: Array,
            default: false,
        },
        geo: {
            type: String,
        },
        defaultRegion: {
            type: String,
        },
    },
    created() {
        var self = this;

        // Fire KTAG tracking event
        setTimeout(function () {
            ktag.reRender();
        }, 500);

        // Listen for a state change
        $('body').on('vueOpList:setState', function (e, state, scope) {
            // Update the link
            if (scope != this.scope) {
                self.state = state;
                self.getProductAndOffer();
            }
        });

        // Check to see if we have a cookie set
        if ($cookies.isKey(this.cookieKey)) {
            this.state = $cookies.get(this.cookieKey);
        } else {
            this.state = this.defaultRegion;
        }

        this.getProductAndOffer();
    },
    data() {
        return {
            product: {},
            offer: {},
            validDestinationLink: false,
            state: false,
            cookieKey: 'op_list_region_' + this.geo.toLowerCase(),
        };
    },
    methods: {
        getProductAndOffer() {
            var self = this;

            this.product = {};
            this.offer = {};

            self.product = this.brandProduct

            self.offer = self.offers.find((offer) => {
                return offer.us_states.some((state) => state.code == self.state);
            });

            if (!self.offer) {
                if (this.geo == 'CA') {
                    // Fallback to Ontario for CA
                    self.offer = self.offers.find((offer) => {
                        return offer.us_states.some((state) => state.code == 'AB');
                    });
                } else {
                    self.offer = this.offers[0];
                }
            }
        },
        getBrandLink() {
            if (this.offer && Object.keys(this.offer).length !== 0) {
                return this.offer.exit_link;
            }
            return false;
        },
        getBrandLabel() {
            return 'Visit ' + this.brand.brand + '<span class="icon-play"></span>';
        },
        getOfferShortDescription() {
            if (Object.keys(this.offer).length !== 0) {
                return this.offer.offer_short_description;
            }
            return '';
        }
    },
};
</script>
